import { detect } from 'detect-browser';
import { isClient } from './isClient.js';

var browser = detect();
var IOS_REG_EXP = /ipad|iphone|ipod/;
function isApplePlatform() {
    return window.navigator.platform.startsWith('Mac') || window.navigator.platform === 'iPhone';
}
function isIOS() {
    if (isClient()) {
        return (IOS_REG_EXP.test(window.navigator.userAgent.toLowerCase()) ||
            (isApplePlatform() && window.navigator.maxTouchPoints > 1));
    }
    return false;
}
function isMacOS() {
    if (isClient() && browser) {
        return browser.os === 'Mac OS';
    }
    return false;
}
var os = {
    isIOS: isIOS,
    isApplePlatform: isApplePlatform,
    isMacOS: isMacOS,
};

export { os };
